export enum BotEventType {
  STATE_CHANGE = 'STATE_CHANGE',
  SIGNAL_FIRED = 'SIGNAL_FIRED',
  SIGNAL_SKIPPED = 'SIGNAL_SKIPPED',
  ORDER_PLACED = 'ORDER_PLACED',
  ORDER_FILLED = 'ORDER_FILLED',
  ORDER_QUEUED = 'ORDER_QUEUED',
  ORDER_REJECTED = 'ORDER_REJECTED',
  ORDER_PARTIAL = 'ORDER_PARTIAL',
  ORDER_ZERO_FILL = 'ORDER_ZERO_FILL',
  ORDER_CANCELLED_EXT = 'ORDER_CANCELLED_EXT',
  DAILY_RESET = 'DAILY_RESET',
  MANUAL_RESET = 'MANUAL_RESET',
  CONFIG_UPDATED = 'CONFIG_UPDATED',
  SESSION_STARTED = 'SESSION_STARTED',
  SESSION_STOPPED = 'SESSION_STOPPED',
  ORDER_SKIPPED_NO_CASH = 'ORDER_SKIPPED_NO_CASH',
  // the buy was sized down to the lots the account's real cash could afford (partial cash)
  ORDER_REDUCED_CASH = 'ORDER_REDUCED_CASH',
  // user set an absolute manual arm-threshold price (top-precedence override)
  MANUAL_THRESHOLD_SET = 'MANUAL_THRESHOLD_SET',
  // the manual arm-threshold override was cleared (manual clear or one-shot fire)
  MANUAL_THRESHOLD_CLEARED = 'MANUAL_THRESHOLD_CLEARED',
  // user cleared the buy cooldown anchor, reverting arming to drop/peak mode
  MANUAL_COOLDOWN_CLEARED = 'MANUAL_COOLDOWN_CLEARED',
  // user restored a previously cleared cooldown anchor (back to shift mode)
  MANUAL_COOLDOWN_RESTORED = 'MANUAL_COOLDOWN_RESTORED',
  // the stream-manager trading-status gate suppressed ticks because the instrument is not
  // in normal trading (or the status is unknown); recorded once per closure, not per tick
  TICK_SUPPRESSED_MARKET_CLOSED = 'TICK_SUPPRESSED_MARKET_CLOSED',
  // the start-of-day reference price (sessionOpenPrice) was backfilled from the official
  // day-open candle at session start / after the daily reset, instead of the first live tick
  SESSION_OPEN_SEEDED = 'SESSION_OPEN_SEEDED',
}
